import { useCallback, useEffect, useState } from 'react'
import { StockDocumentInterface } from '../../../../common/types/interfaces'
import { getSalesApi } from '../../../../salesApi/salesApi'
import { useSelector } from 'react-redux'
import { selectCurrentCluster } from '../../../../store/slices/currentClusterSlice'
import { StockDocumentType } from '../../../../common/types/enums'

const initialDocument: Partial<StockDocumentInterface> = {
  number: '',
  comment: '',
  storeId: undefined,
  movements: [],
}

export const useStock = () => {
  const [modalActive, setModalActive] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false)
  const [salesApi] = useState(getSalesApi())
  const [document, setDocument] = useState<Partial<StockDocumentInterface>>(initialDocument)
  const [documentType, setDocumentType] = useState<StockDocumentType>(StockDocumentType.RECEIPT)
  const [list, setList] = useState<StockDocumentInterface[]>([])
  const [detailsModalActive, setDetailsModalActive] = useState<boolean>(false)
  const [current, setCurrent] = useState<StockDocumentInterface>()
  const currentCluster = useSelector(selectCurrentCluster)
  const [loading, setLoading] = useState(true)

  const getList = useCallback(async () => {
    try {
      const result = await salesApi.getDocumentList()
      
      setLoading(false)
      if (result) setList(result)
    } catch (error) {
      setLoading(false)
    }
  }, [salesApi])

  const startCreate = (type: StockDocumentType) => {
    setEdit(false)
    setDocumentType(type)
    setCurrent(undefined)
    setDocument({ ...initialDocument, movements: [] })
    setModalActive(true)
  }

const startEdit = (el: StockDocumentInterface) => {
  setEdit(true)
  setDocumentType(el.type)
  setCurrent(el)
  setDocument({ ...el })
  setModalActive(true)
}

  const showDetails = useCallback((el: StockDocumentInterface) => {
    setCurrent(el)
    setDetailsModalActive(true)
  }, [])

const addMovement = () => {
  setDocument((prev) => ({
    ...prev,
    movements: [{ saleItemId: '', count: '' }, ...(prev.movements || [])], // 👈 добавляются В НАЧАЛО
  }))
}

  const removeMovement = (index: number) => {
    setDocument((prev) => ({
      ...prev,
      movements: prev.movements?.filter((_, i) => i !== index),
    }))
  }

  const updateMovement = (index: number, field: string, value: any) => {
    setDocument((prev) => ({
      ...prev,
      movements: prev.movements?.map((item, i) =>
        i === index ? { ...item, [field]: value } : item,
      ),
    }))
  }

  useEffect(() => {
    if (currentCluster) getList()
  }, [currentCluster, getList])

  useEffect(() => {
    if (!modalActive) {
      setDocument(initialDocument)
      setDocumentType(StockDocumentType.RECEIPT)
    }
  }, [modalActive])

  return {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    startEdit,
    edit,
    document,
    setDocument,
    documentType,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    addMovement,
    removeMovement,
    updateMovement,
  }
}
